import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M18.74125,5 L17.49125,5 L17.49125,16.25 L11.245,16.25 C11.245,16.9403559 11.8046441,17.5 12.495,17.5 L18.74125,17.5 C19.4316059,17.5 19.99125,16.9403559 19.99125,16.25 L19.99125,6.25 C19.99125,5.55964406 19.4316059,5 18.74125,5 Z M14.9925,2.5 L1.25,2.5 C0.559644063,2.5 0,3.05964406 0,3.75 L0,16.25 C0,16.9403559 0.559644063,17.5 1.25,17.5 L14.9925,17.5 C15.6828559,17.5 16.2425,16.9403559 16.2425,16.25 L16.2425,3.75 C16.2425,3.05964406 15.6828559,2.5 14.9925,2.5 Z M2.5,5.625 L7.4975,5.625 L7.4975,9.375 L2.5,9.375 L2.5,5.625 Z M12.495,14.375 L2.5,14.375 L2.5,13.125 L12.495,13.125 L12.495,14.375 Z M12.495,11.875 L2.5,11.875 L2.5,10.625 L12.495,10.625 L12.495,11.875 Z M12.495,9.375 L8.74625,9.375 L8.74625,8.125 L12.49375,8.125 L12.49375,9.375 L12.495,9.375 Z M12.495,6.875 L8.74625,6.875 L8.74625,5.625 L12.49375,5.625 L12.49375,6.875 L12.495,6.875 Z"
        fill="#00A870"
        fillRule="nonzero"
      />
    </svg>
  )
}

const ImportantNewsIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default ImportantNewsIcon
